// 리소스는 자원으로 인간 생활 및 경제 생산에 이용되는 원료로서의 광물, 산림, 수산물 따위를 통틀 / 경제 인간 생활 및 경제 생산에 이용되는 노동력이나 기술 따위를 통틀어 이르는 말.
// 자산은 개인이나 법인이 소유하고 있는 경제적 가치가 있는 유형ㆍ무형의 재산. 유동 자...

// action types
export const nav = {
    INITIALIZE: 'nav/INITIALIZE',
    // GET_NAVIGATE: 'nav/GET_NAVIGATE',
    SHOW_GLOBAL: 'nav/SHOW_GLOBAL',
};
export const language = {
    INITIALIZE: 'language/INITIALIZE',
    CHANGE_LANGUAGE: 'language/CHANGE_LANGUAGE',
};

// action creators
const navActions = {
    initialize: () => (dispatch) => {
        dispatch({ type: nav.INITIALIZE });
    },
    // getSiteMap: () => async dispatch => {
    //     const result = await axios.get('static/data/sitemap.json').then(response => response.data)
    //     dispatch({ type: nav.GET_NAVIGATE, payload: result })
    // },
    // showGlobal: ({index, depth}) => dispatch => {
    //     dispatch({ type: nav.SHOW_GLOBAL, payload: {index: index, depth: depth} })
    // }
};

export const languageActions = {
    initialize: () => (dispatch) => {
        dispatch({ type: nav.INITIALIZE });
    },
    changeLanguage: (lang) => async (dispatch) => {
        // console.log(lang)
        dispatch({ type: language.CHANGE_LANGUAGE, payload: lang });
        return lang;
    },
};

export default navActions;
